import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import axios from "axios";
import JoditEditorComponent from "../shared/JoditEditorComponent";
import _ from "lodash";
import SuccessModal from "../shared/SuccessModal";
import CitySearchDropdown from "../Dropdowns/CitySearchDropdown";
import SkillsSearchDropdown from "../Dropdowns/SkillsSearchDropdown";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const indianStates = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
];

const CreateProfile = ({ myProfile }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");
  const [skills, setSkills] = useState();
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [degrees, setDegrees] = useState([]);
  const [cities, setCities] = useState([]);
  const [showExperience, setShowExperience] = useState(false);
  const [showSocialLinks, setShowSocialLinks] = useState(false);
  const [showEducation, setShowEducation] = useState(false);
  const [showPersonal, setShowPersonal] = useState(true);

  const filteredStates = indianStates.filter(state =>
    state.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectState = (state) => {
    setSearchTerm(state);
    setShowDropdown(false);
  };

  const [modalConfig, setModalConfig] = useState({
    success: false,
    message: ""
  });

  const initialValuesCandidate = {
    userid: userid,
    city: "",
    college: "",
    university: "",
    passing_year: "",
    degree: "",
    linkedinid: "",
    portfolio: "",
    githubid: "",
    currentcompany: "",
    yearsOfExperience: "",
    currentDesignation: "",
    noticePeriod: "",
    currentSalary: "",
    skills: "",
    dob: "",
    workLocation: "",
    typePartFull: "",
    typeFullIntern: "",
    jobType: "",
    uploadCV: "",
    isactive: true,
    whatsapp_mobile: "",
    gender: "",
    language: "",
    address: "",
    bio: "",
  };

  const [updateData, setUpdateData] = useState(initialValuesCandidate);

  const validationSchema = Yup.object({
    city: Yup.string().required("Please enter city"),
    hometown: Yup.string().required("Please enter hometown"),
    college: Yup.string().required("Please enter your college name"),
    university: Yup.string().required("Please enter your university name"),
    passing_year: Yup.number()
      .typeError("Please enter a valid year")
      .required("Please enter passing year"),
    degree: Yup.string().required("Please enter degree"),
    dob: Yup.string().required("Please enter date of birth"),
    workLocation: Yup.string(),
    jobType: Yup.string().required("Please select a job type"),
    gender: Yup.string().required("Please select gender"),
    country: Yup.string().required("Please enter your country"),
    state: Yup.string().required("Please enter your state"),
    bio: Yup.string().required("Please enter bio"),
    whatsapp_mobile: Yup.number()
      .typeError("Please enter a valid number"),
    // .required("Please enter your mobile number"),
    linkedinid: Yup.string()
      .matches(
        /^(https?:\/\/)?(www\.)?linkedin\.com\/.+$/,
        "Please enter a valid LinkedIn URL"
      ),
    portfolio: Yup.string()
      .matches(
        /^(https?:\/\/)?(www\.)?.+\..+$/,
        "Please enter a valid URL"
      ),
    githubid: Yup.string()
      .matches(
        /^(https?:\/\/)?(www\.)?github\.com\/.+$/,
        "Please enter a valid GitHub URL"
      )

  });
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      let updatedValues = new FormData();

      Object.keys(values).forEach((key) => {
        if (key === "skills") {
          updatedValues.append(key, JSON.stringify(values[key]));
        } else if (key === "uploadCV") {
          updatedValues.append("cv", values.uploadCV);
        } else {
          updatedValues.append(key, values[key]);
        }
      });
      const url = `${process.env.REACT_APP_API_URL}candidate_details/createcandidate`;
      const response = await axios.post(url, updatedValues, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 201) {
        setModalConfig({
          success: true,
          message: "Profile created successfully.",
          onClose: () => {
            setShowModal(false);
            setTimeout(() => {
              navigate("/candidatedashboard");
              window.location.reload();
            }, 100);
          },
        });
      }
    } catch (error) {
      console.error("Error creating profile:", error);
      setModalConfig({
        success: false,
        message: "Can't create profile, please try again",
        onClose: () => {
          setShowModal(false);
        }
      });
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };


  useEffect(() => {
    const fetchAllSkills = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}skills/showallskills`);
        setSkills(response.data || []);
      } catch (error) {
        console.error(error);
        setSkills([]);
      }
    };

    const fetchAllDegrees = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}degree/getdegrees`);
        setDegrees(response.data)
      } catch (error) {
        console.log(error);
      }
    }

    const fetchCities = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}cities/showallcities`);
        setCities(response.data);
        console.log("Cities", cities);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    fetchAllSkills();
    fetchAllDegrees();
    fetchCities();
  }, []);

  useEffect(() => {
    if (myProfile) {
      setUpdateData(myProfile);
    }
  }, [myProfile]);

  return (
    <div className="col-lg-9 w-100">
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Create Your Profile</h4>
          <div className="profile-resume">
            <div className="profile-form">
              <Formik
                enableReinitialize={true}
                initialValues={updateData || initialValuesCandidate}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  if (_.isEqual(values, updateData)) {
                    alert("No Updates made");
                  } else {
                    await handleSubmit(values);
                  }
                }}
              >
                {({ values }) => (
                  <Form>
                    <div className="card p-3 mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="mb-0">Personal Details</h6>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setShowPersonal(!showPersonal)}
                        >
                          {showPersonal ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>
                      {showPersonal && (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Languages Known</label>
                              <div role="group" aria-labelledby="checkbox-group">
                                <Field type="checkbox" name="language" value="Hindi" />
                                <label className="ms-1 me-3">Hindi</label>
                                <Field type="checkbox" name="language" value="English" />
                                <label className="ms-1 me-3">English</label>
                                <Field type="checkbox" name="language" value="Spanish" />
                                <label className="ms-1 me-3">Spanish</label>
                                <Field type="checkbox" name="language" value="Chinese" />
                                <label className="ms-1 me-3">Chinese</label>
                              </div>
                              <ErrorMessage name="language" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Whatsapp Mobile</label>
                              <Field
                                name="whatsapp_mobile"
                                type="number"
                                className="form-control"
                                placeholder="Enter your Whatsapp number"
                              />
                              <ErrorMessage name="whatsapp_mobile" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Date of Birth</label>
                              <Field
                                name="dob"
                                type="date"
                                className="form-control"
                                placeholder="Enter date of birth"
                              />
                              <ErrorMessage name="dob" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Gender</label>
                              <Field as="select" name="gender" className="form-control">
                                <option value="">Choose Gender</option>
                                <option value="1">Male</option>
                                <option value="2">Female</option>
                                <option value="3">Other</option>
                              </Field>
                              <ErrorMessage name="gender" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <Field name="city">
                                {({ field }) => (
                                  <CitySearchDropdown initialValue="" name={field.name} label={field.name} />
                                )}
                              </Field>
                              <ErrorMessage name="city" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Full Address</label>
                              <Field
                                name="address"
                                type="text"
                                className="form-control"
                                placeholder="Enter your full address"
                              />
                              <ErrorMessage name="address" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Bio <span className="text-danger">*</span></label>
                              <Field
                                name="bio"
                                as="textarea"
                                className="form-control"
                                rows="5"
                              />
                              <ErrorMessage name="bio" component="div" className="text-danger" />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Upload CV</label>
                              <Field name="uploadCV">
                                {({ field, form }) => (
                                  <input
                                    type="file"
                                    className="form-control"
                                    accept=".pdf,.doc,.docx"
                                    onChange={(event) =>
                                      form.setFieldValue("uploadCV", event.target.files[0])
                                    }
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="uploadCV"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        </div>

                      )}
                    </div>
                    <div className="card p-3 mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="mb-0">Education / Qualifications</h6>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setShowEducation(!showEducation)}
                        >
                          {showEducation ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>
                      {showEducation && (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>College</label>
                              <Field
                                name="college"
                                type="text"
                                className="form-control"
                                placeholder="Enter your college name"
                              />
                              <ErrorMessage name="college" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>University</label>
                              <Field
                                name="university"
                                type="text"
                                className="form-control"
                                placeholder="Enter your university name"
                              />
                              <ErrorMessage name="university" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Degree</label>
                              <Field as="select" name="degree" className="form-control">
                                <option value="">Choose Degree</option>
                                {degrees.map((degree) => (
                                  <option value={degree.degree_name} key={degree.d_id}>
                                    {degree.degree_name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage name="degree" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Skills</label>
                              <Field name="skills">
                                {({ field, form }) => (
                                  <SkillsSearchDropdown
                                    value={form.values.skills || []}
                                    onChange={(newSkills) => form.setFieldValue("skills", newSkills)}
                                    skillsList={skills || []}
                                  />
                                )}
                              </Field>
                              <ErrorMessage name="skills" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Passing Year</label>
                              <Field as="select" name="passing_year" className="form-control">
                                <option value="">Select Passing Year</option>
                                {Array.from({ length: 2030 - 2015 + 1 }, (_, i) => 2015 + i).map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage name="passing_year" component="div" className="text-danger" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="card p-3 mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="mb-0">Last/current  Work Experience</h6>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setShowExperience(!showExperience)}
                        >
                          {showExperience ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>
                      {showExperience && (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Designation</label>
                              <Field
                                name="currentDesignation"
                                type="text"
                                className="form-control"
                                placeholder="Enter your current Designation"
                              />
                              <ErrorMessage name="currentDesignation" component="div" className="text-danger" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Years Of Experience</label>
                              <Field
                                name="yearsOfExperience"
                                type="text"
                                className="form-control"
                                placeholder="Enter your experience"
                              />
                              <ErrorMessage name="yearsOfExperience" component="div" className="text-danger" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Package (LPA)</label>
                              <Field
                                name="currentSalary"
                                type="text"
                                className="form-control"
                                placeholder="Enter your current Salary"
                              />
                              <ErrorMessage name="currentSalary" component="div" className="text-danger" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Orgnization Company</label>
                              <Field
                                name="currentcompany"
                                type="text"
                                className="form-control"
                                placeholder="Enter your current company"
                              />
                              <ErrorMessage name="currentcompany" component="div" className="text-danger" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="card p-3 mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="mb-0">Social Links</h6>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => setShowSocialLinks(!showSocialLinks)}
                        >
                          {showSocialLinks ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>
                      {showSocialLinks && (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Here you can see my work</label>
                              <Field
                                name="githubid"
                                type="text"
                                className="form-control"
                                placeholder="like GitHub URL"
                              />
                              <ErrorMessage name="githubid" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Portfolio URL</label>
                              <Field
                                name="portfolio"
                                type="url"
                                className="form-control"
                                placeholder="Enter Portfolio URL"
                              />
                              <ErrorMessage name="portfolio" component="div" className="text-danger" />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>LinkedIn URL</label>
                              <Field
                                name="linkedinid"
                                type="url"
                                className="form-control"
                                placeholder="Enter LinkedIn Profile URL"
                              />
                              <ErrorMessage name="linkedinid" component="div" className="text-danger" />
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                    <div className="col-md-12">
                      <div className="form-group mt-3">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Updating..." : "Create Profile"}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showModal}
        onClose={modalConfig.onClose}
        success={modalConfig.success}
        message={modalConfig.message} />
    </div>
  );
};

export default CreateProfile;
